import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

const SsoErrorPage = (props) => {
    const intl = useIntl();

    window.scrollTo(0, 0);

    return (
        <div className="w-100 position-relative text-center">
            <img src="images/errorAuthentication.png" alt="authentication failed" style={{height: 300}}/>

            <h4>{intl.messages.authenticationErrorTitle}</h4>
            <span>{intl.formatMessage({ id: "authenticationErrorMessage" }, { type: props.errorPayload?.errorType })}</span>
            <br />
            <div>
                <span>Error code : {props.errorPayload?.errorCode}</span>
                <br />
                <span>Error message : {props.errorPayload?.errorMessage}</span>
            </div>
        </div>
    );
};

SsoErrorPage.defaultProps = {
    errorPayload: null
};

SsoErrorPage.propTypes = {
    errorPayload: PropTypes.object
};

export default SsoErrorPage;